<template>
    <div :style="{'width': '98%', 'height': '100%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}" class="text-monospace"> 
        <Backer />
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px; text-align: center;">Purchase Orders</div>
        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" style="margin-top: 10px;">
            <div style="width: 100%; overflow: scroll; font-size: 10px;">

                <div>
                    <div style="display: inline-block; vertical-align: top; width: 100%; margin: 5px;">
                        <div style="display: inline-block;">Search: </div>
                        <b-input style="display: inline-block; max-width: 300px; margin-right: 5px; font-size: 12px;" v-on:keyup="filterPurchaseOrders" v-model="query" placeholder="Filter by PO #, Container #, Vendor, SKU, etc." size="sm"></b-input>
                        <div style="display: inline-block;">
                            <div style="display: inline-block;">Order By: </div>
                            <div style="display: inline-block;">
                                <b-form-select
                                    v-model="order_key"
                                    :options="order_keys"
                                    size="sm"
                                    v-on:change="sortby"
                                >
                                </b-form-select>
                            </div>
                        </div>

                        <div style="display: inline-block;">
                            <div style="display: inline-block;">Filter Status: </div>
                            <div style="display: inline-block;">
                                <b-form-select
                                    v-model="filter_key"
                                    :options="production_statuses"
                                    size="sm"
                                    v-on:change="filterby"
                                >
                                </b-form-select>
                            </div>

                        </div>
                    </div>
                </div>

                <div>
                    <smart-pagination
                        :currentPage.sync="currentPage"
                        :totalPages="totalPages"
                    />
                    <v-table style="width: 3000px;" 
                        :data="purchase_orders_to_show" 
                        :currentPage.sync="currentPage"
                        :pageSize="pageSize"
                        @totalPagesChanged="totalPages = $event"

                    >
                        <thead slot="head">
                            <tr style="background: #f2f2f2;">
                                <td class="ipt_tdhr" style="width: 80px;">
                                    PI/PO#
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    INVCE #
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    CONTAINER #
                                </td>
                                <td class="ipt_tdhr" style="width: 60px;">
                                    VENDOR 
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    CATEGORIES 
                                </td>
                                <td class="ipt_tdhr" style="width: 150px;">
                                    ITEMS
                                </td>
                                <td class="ipt_tdhr" style="width: 150px;">
                                    STATUS
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    COLORS 
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    ORDER DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    REQUESTED SHIP DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    PRODUCTION START DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    ETD
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    RELEASE DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    ETA
                                </td>
                                <td class="ipt_tdhr" style="width: 180px;">
                                    FOB PRICES
                                </td>
                                <td class="ipt_tdhr" style="width: 60px;">
                                    TARIFF
                                </td>
                                <td class="ipt_tdhr" style="width: 60px;">
                                    INVOICE AMT
                                </td>
                                <td class="ipt_tdhr" style="width: 150px;">
                                    ACTION
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    DUE DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    INVOICE PAID DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 60px;">
                                    RECEIVED LOCATION
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT INVOICE DATE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT COMPANY
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT INVOICE #
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT INVOICE AMT
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT PAYMT TYPE
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT PAID ON
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    FREIGHT PAID BY
                                </td>
                                <td class="ipt_tdhr" style="width: 80px;">
                                    TRUCK INVOICE DATE
                                </td>

                                <td class="ipt_tdhr" style="width: 80px;">
                                    TRUCK COMPANY
                                </td>

                                <td class="ipt_tdhr" style="width: 80px;">
                                    TRUCK INVOICE #
                                </td>

                                <td class="ipt_tdhr" style="width: 80px;">
                                    TRUCK INVOICE AMT
                                </td>

                                <td class="ipt_tdhr" style="width: 80px;">
                                    TRUCK PAID ON
                                </td>

                                <td class="ipt_tdhr" style="width: 80px;">
                                    TRUCK PAID BY
                                </td>
                            </tr>
                        </thead>

                        <tbody slot="body" slot-scope="{displayData}">
                            <tr v-for="purchase_order, idx in displayData" v-bind:key="idx">
                                <td class="ipt_tdhr">
                                    {{ (purchase_order.po_number || "") }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ (purchase_order.invoice_number || "") }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ (purchase_order.container_number || "") }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ packet.vendorsdict[purchase_order.vendor_id] }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ purchase_order.categories }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ purchase_order.items }}
                                </td>
                                <td class="ipt_tdhr" :style="{background: get_prod_stat_color(purchase_order.production_status)}">
                                    {{ production_statuses_dict[purchase_order.production_status].toUpperCase() }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ purchase_order.colors }}
                                </td>
                                <td class="ipt_tdhr">
                                    <div>{{ parse_dt(purchase_order.created_on) }}</div>

                                    <div>({{ purchase_order.created_by }})</div>
                                </td>
                               
                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.requested_ship_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.production_start_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.etd" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                  
                                </td>
                                
                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.release_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.eta" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr">
                                    <b-input v-model="purchase_order.fob_prices" size="sm" style="font-size: 11px;"></b-input>
                                </td>

                                <td class="ipt_tdhr">
                                    <b-input v-model="purchase_order.tariff" size="sm" style="font-size: 11px;"></b-input>
                                </td>
                                <td class="ipt_tdhr">
                                    <b-input v-model="purchase_order.invoice_amount" size="sm" style="font-size: 11px;"></b-input>
                                </td>
                                <td class="ipt_tdhr">
                                    <b-button size="sm" style="margin: 3px;" variant="success" @click="updatePurchaseOrder(purchase_order)">SAVE</b-button>
                                    <b-button size="sm" style="margin: 3px;"  variant="primary" @click="navigateToPurchaseOrder(purchase_order.po_number)">VIEW</b-button>
                                </td>
                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.due_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr">
                                    <flat-pickr v-model="purchase_order.invoice_paid_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr">
                                    {{ packet.locsubsdict[purchase_order.locsub] }}
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <flat-pickr v-model="purchase_order.freight_invoice_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px; background: transparent;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <b-input v-model="purchase_order.freight_company" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <b-input v-model="purchase_order.freight_invoice_number" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <b-input v-model="purchase_order.freight_invoice_amount" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <b-input v-model="purchase_order.freight_payment_type" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <flat-pickr v-model="purchase_order.freight_invoice_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px; background: transparent;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr" style="background: #FFE082;">
                                    <b-input v-model="purchase_order.freight_paid_by" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #dcedc8;">
                                    <flat-pickr v-model="purchase_order.truck_invoice_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px; background: transparent;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr" style="background: #dcedc8;">
                                    <b-input v-model="purchase_order.truck_company" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #dcedc8;">
                                    <b-input v-model="purchase_order.truck_invoice_number" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #dcedc8;">
                                    <b-input v-model="purchase_order.truck_invoice_amount" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>

                                <td class="ipt_tdhr" style="background: #dcedc8;">
                                    <flat-pickr v-model="purchase_order.truck_paid_on" :config="{ dateFormat: 'm-d-Y' }" style="padding: 0px; text-align: center; border: 0px;  font-size: 10px; width: 80px; height: 30px;  background: transparent;"></flat-pickr>
                                </td>

                                <td class="ipt_tdhr" style="background: #dcedc8;">
                                    <b-input v-model="purchase_order.truck_paid_by" size="sm" style="font-size: 11px; background: transparent;"></b-input>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>

                <!-- <div v-for="purchase_order, idx in purchase_orders_to_show" v-bind:key="idx" style="margin-top: 10px;">

                    <b-card-group column>
                        <b-card >
                            <b-card-body style="font-size: 12px; padding: 3px;">
                                <div style="margin-top: 5px; font-size: 16px;">
                                    <div style="width: 100px; display: inline-block;">PO#</div>
                                    <b><div style="display: inline-block; ">{{ (purchase_order.po_number || "") }}</div></b>
                                </div>

                                <div style="margin-top: 5px;">
                                    <div style="width: 100px; display: inline-block;">CONTNR#</div>
                                    <div style="display: inline-block;">{{ (purchase_order.container_number || "") }}</div>
                                </div>

                                <div style="margin-top: 5px;">
                                    <div style="width: 100px; display: inline-block;">VENDR</div>
                                    <div style="display: inline-block;">{{ packet.vendorsdict[purchase_order.vendor_id] }}</div>
                                </div>

                                <div style="margin-top: 5px;">
                                    <div style="width: 100px; display: inline-block;">ETA</div>
                                    <div style="display: inline-block;">
                                        <b-form-datepicker 
                                            reset-button
                                            size="sm" 
                                            placeholder="" 
                                            v-model="purchase_order.eta"
                                            style="width: 150px; display: inline; font-size: 13px;"
                                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                        >
                                        </b-form-datepicker>
                                    </div>
                                </div>

                                <div style="margin-top: 5px;">
                                    <div style="width: 100px; display: inline-block;">STATUS</div>
                                    <div style="display: inline-block;">
                                        <b-form-select
                                            v-model="purchase_order.production_status"
                                            :options="production_statuses"
                                            size="sm"
                                            style="width: 150px; margin: auto; font-size: 13px;"
                                        >
                                        </b-form-select>
                                    </div>

                                </div>

                                <div style="margin-top: 5px;">
                                    <div style="width: 100px; display: inline-block;">CREATED</div>
                                    <div style="display: inline-block;">
                                        {{ purchase_order.created_on }} 

                                        ({{ purchase_order.created_by }})
                                        </b-form-select>
                                    </div>
                                </div>

                                <div style="margin-top: 5px;">
                                    <div style="width: 100px; display: inline-block;">LAST SAVED</div>
                                    <div style="display: inline-block;">
                                        {{ purchase_order.last_saved_on }} 

                                        ({{ purchase_order.last_saved_by }})
                                        </b-form-select>
                                    </div>
                                </div>
                            </b-card-body>

                        </b-card>

                        <b-card sub-title="ITEMS" >

                            <b-card-body style="font-size: 12px; padding: 3px;">

                                <table style="width: 100%;">
                                    <thead>
                                        <tr style="background-color: #efefef;">
                                            <td class="ipt_tdhr">SKU</td>
                                            <td class="ipt_tdhr">Location</td>
                                            <td class="ipt_tdhr">ORD</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item, itemidx in purchase_order.items" v-bind:key="itemidx">
                                            <td class="ipt_tdhr" :style="{'color': ((item.is_custom) ? 'crimson' : 'inherit' )}">{{ item.product_sku }}</td>

                                            
                                            <td class="ipt_tdhr">{{ packet.locationsdict[item.location_id] }} / {{ packet.sublocationsdict[item.sublocation_id] }}</td>

                                            <td class="ipt_tdhr" style="width: 70px;">
                                                <div style="text-align: center; background: #d8f4c3;">
                                                    
                                                    {{ item.ordered_quantity }}
                                                </div>
                                            </td>
                                            
                                            
                                        </tr>
                                    </tbody>
                                </table>

                                <b-card-text style="margin-top: 10px; text-align: center;">
                                    <b-button size="sm" variant="success" @click="navigateToPurchaseOrder(purchase_order.po_number)">View</b-button>

                                    <b-button size="sm" variant="danger"  @click="updatePurchaseOrder(idx)">Update</b-button>
                                </b-card-text>

                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </div> -->
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    import moment from 'moment'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        name: "ListPurchaseOrders",
        components: {Backer, VueGoodTable, Multiselect, flatPickr},
        data: function() {
            return {
                userDetails: {properties: {}},
                purchase_orders: [],
                purchase_orders_to_show: [],
                items_being_loaded: false,
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                vendors: [],
                vendorsdict: {},
                categories: [],
                categoriesdict: {},
                query: null,
                order_key: null,
                order_keys: [
                    {value: "eta_asc", text: "ETA (Asc)"},
                    {value: "eta_desc", text: "ETA (Desc)"},
                    {value: "date_created_asc", text: "Date Created (Asc)"},
                    {value: "date_created_desc", text: "Date Created (Desc)"},
                    {value: "last_saved_on_asc", text: "Last Updated (Asc)"},
                    {value: "last_saved_on_desc", text: "Last Updated (Desc)"},
                    {value: "created_by", text: "Created By"},
                    {value: "last_saved_by", text: "Saved By"},
                    {value: "vendor_id", text: "Vendor"},
                    {value: "categories", text: "Category"}
                ],
                production_statuses: [
                    {value: null, text: "All Orders"},
                    {value: 1, text: "Open Orders"},
                    {value: 2, text: "In Production"},
                    {value: 3, text: "Ready to Ship"},
                    {value: 4, text: "In Transit"},
                    {value: 5, text: "Received"}
                ],
                production_statuses_dict: {
                    1: "Open Orders",
                    2: "In Production",
                    3: "Ready to Ship",
                    4: "In Transit",
                    5: "Received"
                },
                production_statuses_colors: {
                    1: "yellow",
                    2: "#f5f5dc",
                    3: "#c5e1a5",
                    4: "#a5bfe1",
                    5: "#c5e1a5"
                },
                filter_key: 1,
                currentPage: 1,
                totalPages: 0,
                pageSize: 50
            }
        },
        methods: {
            get_prod_stat_color: function(production_status){
                return this.production_statuses_colors[production_status]
            },
            parse_dt: function(dt){
                return moment(dt).format("MM-DD-YYYY")
            },
            getDelta: function(idx, itemidx){
                let item = this.purchase_orders_to_show[idx].items[itemidx];
                let ordered_quantity = parseInt(item.ordered_quantity);
                let received_quantity = parseInt(item.received_quantity);
                let damaged_quantity = parseInt(item.damaged_quantity);

                if (isNaN(ordered_quantity) == false &&  isNaN(received_quantity) == false && isNaN(damaged_quantity) == false){
                    return ordered_quantity - (received_quantity + damaged_quantity);
                }
                else {
                    return 0
                }
            },
            getDeltaCondition: function(idx, itemidx){
                let delta = this.getDelta(idx, itemidx);
                    
                if (delta > 0){
                    return true
                }
                else {
                    return false
                }
            },
            getProductionStatusBG: function(production_status){
                let out = this.production_statuses.filter(function(d){return d.value == production_status});
                if (out){
                    return out[0].color
                }
                else {
                    return '#efefef'
                }
            },
            filterby: function(){
                let filter_key = this.filter_key;
                let that = this;

                this.items_being_loaded = true
                if (!filter_key){
                    this.purchase_orders_to_show = this.purchase_orders;
                    
                    this.items_being_loaded = false
                    return
                }
                this.purchase_orders_to_show =  this.purchase_orders.filter(function(d){
                    return (
                        d.production_status == filter_key
                    )
                });
                this.items_being_loaded = false
            },
            filterPurchaseOrders: function(){
                let query = this.query;
                let that = this;
                this.purchase_orders_to_show =  this.purchase_orders.filter(function(d){
                    return (
                        d.container_number.toLowerCase().indexOf(query.toLowerCase()) > -1  
                        ||
                        d.po_number.toLowerCase().indexOf(query.toLowerCase()) > -1
                        ||
                        that.packet.vendorsdict[d.vendor_id].toLowerCase().indexOf(query.toLowerCase()) > -1
                        ||
                        d.items.toLowerCase().indexOf(query.toLowerCase()) > -1
                    )
                });
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                ];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else{
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function(){
                let that = this;
                let path = "/api/inventory/get_purchase_orders/";
                let data = {};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {

                        that.purchase_orders = response.data.result;
                        that.purchase_orders_to_show = response.data.result;
                    }
                    that.items_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading purchase orders.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                    return
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            navigateToPurchaseOrder: function(po_number){
                this.$router.push("/purchase_orders/"+po_number+"/");
            },
            sortby: function(key){
                this.items_being_loaded = true;
                if (key == "eta_asc"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "eta")
                }
                if (key == "eta_desc"){
                    this.purchase_orders_to_show = Requestor.sort_reverse(this.purchase_orders_to_show, "eta")
                }
                if (key == "date_created_asc"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "created_on")
                }
                if (key == "date_created_desc"){
                    this.purchase_orders_to_show = Requestor.sort_reverse(this.purchase_orders_to_show, "created_on")
                }
                if (key == "last_saved_on_asc"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "last_saved_on")
                }
                if (key == "last_saved_on_desc"){
                    this.purchase_orders_to_show = Requestor.sort_reverse(this.purchase_orders_to_show, "last_saved_on")
                }
                if (key == "created_by"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "created_by")
                }
                if (key == "last_saved_by"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "last_saved_by")
                }
                if (key == "vendor_id"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "vendor_id")
                }
                if (key == "categories"){
                    this.purchase_orders_to_show = Requestor.sort(this.purchase_orders_to_show, "categories")
                }
                this.items_being_loaded = false;

            },
            updatePurchaseOrder: function(purchase_order){
                let item = purchase_order;
                let data = item;
                data.last_saved_by = this.packet.userDetails.username;
                //data.last_saved_on = moment(dt).format("MM-DD-YYYY HH:MM:SS")
                
                let path = "/api/inventory/update_purchase_order/"
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "PO # "+data.po_number+" Updated!", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        data.last_saved_on = response.data.result.last_saved_on;
                        data.last_saved_by = that.packet.userDetails.username;
                    }
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error updating purchase order", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                Requestor.postSyncP(path, data, this, s, f);
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails); 
            this.fetch_prereqs();
            this.fetch_init();
        }
    }

</script>

<style scoped>
    .info_table td {
        font-size: 10px;
        background: #fafafa;
        text-align: center;
        
        border: 1px solid #efefef;
    }

    .ipt_tdr, .ipt_tdhr {
        font-size: 10px !important;
    
        border: 1px solid steelgray;
        color: steelgray;
        font-weight: normal;
        padding: 0px;
    }

</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrders/ListPurchaseOrders.vue